import type { ReactElement, ReactNode } from "react";

/** Plain-language explanation shown at the top of a screen, so admins know what it is for. */
export function PageHelp({ children, label = "About this screen" }: { children: ReactNode; label?: string }): ReactElement {
  return (
    <aside className="page-help" aria-label={label}>
      {children}
    </aside>
  );
}
